import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactSupportButton } from '../components/button/ContactSupportButton';
import { NoAuthPlaceholder } from '../components/illustrations/NoAuthPlaceholder';

/**
 * The page to show when a user is not authenticated and we fail to redirect them to Okta
 */
export const NoAuthPage = () => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState(false);

  // Prevents the page from flashing if we
  // are waiting for auth to be established
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!showContent) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <NoAuthPlaceholder />
      <div className="flex flex-row gap-2 mt-4">
        <ContactSupportButton />
        <Button onClick={() => window.location.reload()}>
          {t('refreshPage')}
        </Button>
      </div>
    </div>
  );
};
